var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.765015 0.426636H5.43715V5.09877H0.765015V0.426636ZM0.765015 7.43483H5.43715V12.107H0.765015V7.43483ZM0.765015 14.443H5.43715V19.1152H0.765015V14.443ZM7.77321 0.426636H12.4453V5.09877H7.77321V0.426636ZM7.77321 7.43483H12.4453V12.107H7.77321V7.43483ZM7.77321 14.443H12.4453V19.1152H7.77321V14.443ZM14.7814 0.426636H19.4535V5.09877H14.7814V0.426636ZM14.7814 7.43483H19.4535V12.107H14.7814V7.43483ZM14.7814 14.443H19.4535V19.1152H14.7814V14.443Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.d6a53cd2c667691586e300b6b121c6a2.svg";
export { ForwardRef as ReactComponent };